import { shallowMount } from "@vue/test-utils";
import ModalClaveUsuario from "@/components/core/modals/ModalClaveUsuario";

describe("ModalClaveUsuario component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(ModalClaveUsuario);
  });

  it("Renders del component ModalClaveUsuario", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
